import moment from 'moment';

export const isDateTomorrow = (date: Date | string): boolean => {
    const endOfToday = moment().endOf('day');
    const endOfTomorrow = moment().add(1, 'day').endOf('day');

    return moment(date).isBetween(endOfToday, endOfTomorrow);
};
